export const icons = [
  "icon-pool",
  "icon-buffet",
  "icon-parking",
  "icon-doctor-2",
  "icon-ventilation",
  "icon-ball-free",
  "icon-spectator-stand",
  "icon-jacuzzi",
  "icon-lockerroom",
  "icon-roofgarden",
  "icon-steam-sauna",
  "icon-dry-sauna",
  "icon-cooling-system",
  "icon-sports-shop",
  "icon-shop-2",
  "icon-coffee-shop",
  "icon-massage",
  "icon-coach",
  "icon-wc",
  "icon-water-cooler",
  "icon-pool-children",
];
